module.exports = __webpack_public_path__ + "img/category-brand-hover.7d285add.png";